<header class="title-header pt-7">
  <div class="title-content">
    <span class="material-symbols-outlined title-icon">
      receipt_long
    </span>
    <h1 class="title-text"> 
      Cotizaciones 
    </h1>
  </div>

  <button class="add-button-top" (click)="openModal()">
    + Agregar cotización
  </button>
</header>

<!-- Subheader -->
<div class="mt-4 flex flex-wrap items-center justify-between bg-gray-50 p-3 rounded-lg shadow-sm">
  <p class="sub-heading-2">
    Total: {{ filteredQuotations.length }} Cotizaciones
  </p>

  <div class="flex items-center gap-3">
    <!-- Ordenar -->
    <div class="relative">
      <select
        class="border border-gray-200 font-medium rounded-lg px-3 py-2 text-sm text-gray-700 bg-white"
        [(ngModel)]="sortOption"
        (change)="sortQuotations(sortOption)"
      >
        <option value="fecha">Ordenar: Fecha de Carga</option>
        <option value="alfabetico">Ordenar: Alfabéticamente</option>
      </select>
    </div>

    <!-- Filtro -->
    <div class="flex items-center">
      <!-- Botón de filtro -->
      <div class="gap-1 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 bg-white">
        <button class="filter-button "
          (click)="showFilterModal = true">
          <span>Filtrar</span>
          <span class="material-symbols-outlined text-gray-900 font-medium">filter_alt</span>
        </button>
      </div>

      <!-- Modal de filtro -->
      <app-filter-quotation-modal
        *ngIf="showFilterModal"
        [currentFilters]="currentFilters"
        (close)="showFilterModal = false"
        (applyFilters)="onApplyFilters($event)">
      </app-filter-quotation-modal>
    </div>
  </div>
</div>

<!--Indicador de filtros activos-->
<div *ngIf="hasActiveFilters()" class="mt-3 flex flex-wrap items-center gap-3 bg-blue-50 border border-blue-200 p-3 rounded-lg text-sm text-blue-900">
  <span class="font-medium flex items-center gap-1">
    <span class="material-symbols-outlined text-blue-600 text-base">
      tune
    </span>
    Filtros aplicados:
  </span>
  <span *ngIf="filterText" class="bg-blue-100 px-2 py-1 rounded-lg text-blue-800 flex items-center gap-1">
    Nombre: "{{ filterText }}"
  </span>

  <span *ngIf="filterStartDate" class="bg-blue-100 px-2 py-1 rounded-lg text-blue-800 flex items-center gap-1">
    Desde: {{ filterStartDate | date: 'dd/MM/yyyy' }}
  </span>

  <span *ngIf="filterEndDate" class="bg-blue-100 px-2 py-1 rounded-lg text-blue-800 flex items-center gap-1">
    Hasta: {{ filterEndDate | date: 'dd/MM/yyyy' }}
  </span>

  <button class="ml-auto flex items-center gap-1 clear-filter-button" (click)="clearAllFilters()">
    <span class="material-symbols-outlined text-sm">close</span>
    Limpiar filtros
  </button>
</div>


<!-- Tabla -->
<section class="p-6">
  <table class="w-full border-collapse bg-white rounded-xl shadow">
    <thead class="bg-gray-100 text-gray-900 text-sm">
      <tr>
        <th class="text-left py-3 px-4">Cotización</th>
        <th class="text-center py-3 px-4">Descarga</th>
        <th class="text-right py-3 px-4">Fecha de carga</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let q of filteredQuotations" class="hover:bg-gray-50">
        <td class="text-gray-800 py-3 px-4">{{ q.name }}</td>
        <td class="text-gray-800 py-3 px-4 text-center text-blue-500 cursor-pointer hover:underline">
          {{ q.status }}
        </td>
        <td class="text-gray-800 py-3 px-4 text-right">{{ q.uploadDate }}</td>
      </tr>
      <tr *ngIf="filteredQuotations.length === 0">
        <td colspan="3" class="text-center py-6 text-gray-400">
          No hay cotizaciones cargadas.
        </td>
      </tr>
    </tbody>
  </table>
</section>

<!-- Modal -->
<app-upload-quotation-modal *ngIf="showModal" (close)="closeModal()" (fileUploaded)="handleFileUpload($event)" />